import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './user-custom.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const UserCustomDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const userCustomEntity = useAppSelector(state => state.userCustom.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userCustomDetailsHeading">
          <Translate contentKey="fleetSenseApp.userCustom.detail.title">UserCustom</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{userCustomEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="phone">
              <Translate contentKey="fleetSenseApp.userCustom.phone">Phone</Translate>
            </span>
          </dt>
          <dd>{userCustomEntity.phone}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.userCustom.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{userCustomEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <span id="registry">
              <Translate contentKey="fleetSenseApp.userCustom.registry">Registry</Translate>
            </span>
          </dt>
          <dd>{userCustomEntity.registry}</dd>
          <dt>
            <span id="identificationCode">
              <Translate contentKey="fleetSenseApp.userCustom.identificationCode">Identification Code</Translate>
            </span>
          </dt>
          <dd>{userCustomEntity.identificationCode}</dd>
          <dt>
            <span id="licenseValidity">
              <Translate contentKey="fleetSenseApp.userCustom.licenseValidity">License Validity</Translate>
            </span>
          </dt>
          <dd>
            {userCustomEntity.licenseValidity ? (
              <TextFormat value={userCustomEntity.licenseValidity} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fleetSenseApp.userCustom.user">User</Translate>
          </dt>
          <dd>{userCustomEntity.user ? userCustomEntity.user.login : ''}</dd>
          {/* <dt>
            <Translate contentKey="fleetSenseApp.userCustom.company">Company</Translate>
          </dt>
          <dd>{userCustomEntity.company ? userCustomEntity.company.name : ''}</dd> */}
        </dl>
        <Button tag={Link} to="/user-custom" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-custom/${userCustomEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserCustomDetail;
